import React, { memo } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

function FlagBadge({ number, className }) {
  const finalClassNames = classNames('flag-badge', className);

  return <span className={finalClassNames}>{number}</span>;
}

FlagBadge.defaultProps = {
  className: '',
};

FlagBadge.propTypes = {
  number: propTypes.number.isRequired,
  className: propTypes.string,
};

const memoizedFlagBadge = memo(FlagBadge);

export { memoizedFlagBadge as FlagBadge };
